"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactComponents = require("@canonical/react-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Filters(_ref) {
  let {
    categories,
    selectedCategories,
    setSelectedCategories,
    platforms,
    selectedPlatform,
    setSelectedPlatform,
    packageTypes,
    selectedPackageType,
    setSelectedPackageType,
    architectures,
    selectedArchitecture,
    setSelectedArchitecture,
    disabled,
    showFeatured,
    order,
    showMore,
    showMoreCount,
    displayAllCategories
  } = _ref;
  const [showAllCategories, setShowAllCategories] = (0, _react.useState)(displayAllCategories || false);
  const categoryCount = showMoreCount ? showMoreCount - 1 : 9;
  const handleSelectedCategoriesChange = (event, categoryName) => {
    const target = event.target;
    let newSelectedCategories = [...selectedCategories];
    if (target.checked) {
      newSelectedCategories = [...selectedCategories, categoryName];
    } else {
      newSelectedCategories.splice(newSelectedCategories.indexOf(categoryName), 1);
    }
    setSelectedCategories(newSelectedCategories.sort());
  };
  let sortedCategories = [];
  if (order && order.length > 0) {
    order.forEach(item => {
      const category = categories.find(cat => cat.name === item);
      if (category) {
        sortedCategories.push(category);
      }
    });
    categories.forEach(cat => {
      if (!order.includes(cat.name)) {
        sortedCategories.push(cat);
      }
    });
  } else {
    sortedCategories = categories;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "p-muted-heading"
  }, "Categories"), showFeatured && /*#__PURE__*/_react.default.createElement(_reactComponents.CheckboxInput, {
    disabled: disabled,
    key: "featured",
    label: "Featured",
    onChange: event => {
      handleSelectedCategoriesChange(event, "featured");
    },
    checked: selectedCategories?.includes("featured")
  }), sortedCategories.length > 0 && sortedCategories.map((category, index) => /*#__PURE__*/_react.default.createElement(_reactComponents.CheckboxInput, {
    disabled: disabled,
    key: category.name,
    label: category.display_name,
    labelClassName: showMore && !showAllCategories && index > categoryCount ? "u-hide" : "",
    onChange: event => {
      handleSelectedCategoriesChange(event, category.name);
    },
    checked: selectedCategories?.includes(category.name)
  })), showMore && sortedCategories && sortedCategories.length > categoryCount && !showAllCategories && /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    className: "has-icon p-button--link",
    onClick: () => {
      setShowAllCategories(true);
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, "Show more"), /*#__PURE__*/_react.default.createElement(_reactComponents.Icon, {
    name: "chevron-down"
  })), showMore && showAllCategories && /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    className: "has-icon p-button--link",
    onClick: () => {
      setShowAllCategories(false);
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, "Show less"), /*#__PURE__*/_react.default.createElement(_reactComponents.Icon, {
    name: "chevron-up"
  })), platforms && /*#__PURE__*/_react.default.createElement(_reactComponents.Select, {
    disabled: disabled,
    defaultValue: selectedPlatform,
    id: "platforms",
    label: "Platforms",
    options: platforms.map(platform => {
      return {
        label: platform.display_name,
        value: platform.name
      };
    }),
    onChange: e => {
      setSelectedPlatform(e.target.value);
    }
  }), packageTypes && /*#__PURE__*/_react.default.createElement(_reactComponents.Select, {
    disabled: disabled,
    defaultValue: selectedPackageType,
    id: "package-types",
    label: "Filter by",
    options: packageTypes.map(packageType => {
      return {
        label: packageType.display_name,
        value: packageType.name
      };
    }),
    onChange: e => {
      setSelectedPackageType(e.target.value);
    }
  }), architectures && /*#__PURE__*/_react.default.createElement(_reactComponents.Select, {
    disabled: disabled,
    defaultValue: selectedArchitecture,
    id: "package-types",
    label: "Architecture",
    options: architectures.map(architecture => {
      return {
        label: architecture.display_name,
        value: architecture.name
      };
    }),
    onChange: e => {
      setSelectedArchitecture(e.target.value);
    }
  }));
}
Filters.propTypes = {
  selectedCategories: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  platforms: _propTypes.default.arrayOf(_propTypes.default.shape({
    display_name: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired
  })),
  packageTypes: _propTypes.default.arrayOf(_propTypes.default.shape({
    display_name: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired
  })),
  architectures: _propTypes.default.arrayOf(_propTypes.default.shape({
    display_name: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired
  })),
  disabled: _propTypes.default.bool.isRequired,
  showFeatured: _propTypes.default.bool,
  order: _propTypes.default.arrayOf(_propTypes.default.string),
  showMore: _propTypes.default.bool,
  showMoreCount: _propTypes.default.number,
  displayAllCategories: _propTypes.default.bool
};
var _default = exports.default = Filters;